<p>2024</p>
<p>An almost-documentary about getting a PhD from a diploma mill in Metaphysics.</p>
<app-embedded-video [videoId]="videoId"></app-embedded-video>
